module.exports = __webpack_public_path__ + "img/icon_task_default.3b198e68.svg";